export default {"src":"/_next/static/media/empty-cart.3b4e70c6.svg","height":126,"width":307,"blurWidth":0,"blurHeight":0};